import { useEffect, useState } from "react";
import useS3 from "../../../../../hooks/useS3";
import ReportImage from "./reportImage";

interface props {
  dir: string;
}

const API = import.meta.env.VITE_API;

export default function ReportImages({ dir }: props) {
  const { getObjectsInDir, getFilesInTempDir } = useS3();

  const [images, setImages] = useState<string[]>([]);

  const getImages = async () => {
    const imageStrings = [];
    const res = await getObjectsInDir(dir);
    if (res && res.Contents) {
      const { Contents } = res;
      const objectKeysOnly = Contents.filter(c => c.Size && c.Size > 0)
        .map(c => c.Key)
        .filter(c => c) as string[];

      imageStrings.push(...objectKeysOnly);
    }

    const tempFiles = await getFilesInTempDir(dir);

    if (tempFiles && tempFiles.length > 0) {
      const filtered = tempFiles
        .filter(file => file.includes("."))
        .map(file => `${API}/${dir}/${file}`);

      imageStrings.push(...filtered);
    }

    setImages(imageStrings);
  };

  useEffect(() => {
    getImages();
  }, [dir]);

  return (
    <div className="col-span-full flex flex-col md:gap-1">
      <label className="text-black px-3 md:px-0 bg-gray-100 md:bg-transparent pt-3 md:pt-0 print:pt-0 print:bg-transparent">
        관련 사진
      </label>
      <div className="grid grid-cols-3 gap-4 p-4 md:p-2 md:pt-4 bg-gray-100 md:rounded-md print:rounded-md">
        {images.map(image => (
          <ReportImage key={image} image={image} />
        ))}
      </div>
    </div>
  );
}
